import React from 'react';

import {
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
  Validator,
} from 'react-admin';

import EditFieldLayout from '../components/layout/EditFieldLayout';

const EditReferenceField = ({
  showEdit,
  label,
  source,
  reference,
  validate,
  optionText = 'name',
  filter,
  perPage = 200,
  emptyText = '-',
}: {
  showEdit: boolean;
  label: string;
  source: string;
  reference: string;
  validate?: Validator | Validator[];
  optionText?: string;
  filter?: Record<string, unknown>;
  perPage?: number;
  emptyText?: string;
}) => (
  <EditFieldLayout
    source={source}
    label={label}
    showEdit={showEdit}
    inputElement={(
      <ReferenceInput
        source={source}
        reference={reference}
        filter={filter}
        perPage={perPage}
      >
        <SelectInput
          optionText={optionText}
          validate={validate}
          label={false}
          helperText={false}
        />
      </ReferenceInput>
    )}
    fieldElement={(
      <ReferenceField source={source} reference={reference} empty={emptyText}>
        <TextField source={optionText} />
      </ReferenceField>
    )}
  />
);

export default EditReferenceField;
